import { Injectable } from "@angular/core";
import { HTTP_INTERCEPTORS, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

@Injectable()
export class VersionInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.includes("/api/")) {
      const clonedRequest = req.clone({
        headers: req.headers.set("version", environment.version),
      });

      return next.handle(clonedRequest);
    }

    return next.handle(req);
  }
}

export const versionInterceptorProvider = {
  provide: HTTP_INTERCEPTORS,
  useClass: VersionInterceptor,
  multi: true,
};
